<template>
  <div class="details-reader-primitive app-key-value__row">
    <span class="app-key-value__key">
      {{ detailsKey | readableCamelCase | formatCommonAbbreviations }}
    </span>

    <template v-if="copyable && detailsValue">
      <copyable
        class="app-key-value__value"
        :copy-text="detailsValue">
        {{ formatData(detailsValue) }}
      </copyable>
    </template>
    <template v-else>
      <span
        class="app-key-value__value"
        :title="detailsValue">
        {{ formatData(detailsValue, detailsKey) }}
      </span>
    </template>
  </div>
</template>

<script>
import { globalize } from '@/vue/filters/globalize'
import { validateDate } from '@validators'
// import { formatDateDMYT } from '@/vue/filters/formatDateDMYT'
import Copyable from '@/vue/common/copyable/Copyable'
import { shortener } from '@/js/helpers/string'

export default {
  name: 'details-reader-primitive',
  components: {
    'copyable': Copyable,
  },
  props: {
    detailsKey: {
      type: [String],
      required: true,
    },
    detailsValue: {
      type: [String, Number, Boolean],
      default: '',
    },
    copyable: {
      type: Boolean,
      default: false,
    },
    shortable: {
      type: Boolean,
      default: false,
    },
    formatters: {
      type: [Array],
      default: () => [],
    },
  },
  methods: {
    isObject (value) {
      return value instanceof Object
    },
    isDate (value) {
      return validateDate(value)
    },
    isBoolean (value) {
      return typeof value === 'boolean'
    },
    formatData (value, key) {
      const formatters = this.formatters.filter(row => row.key === key)
      if (formatters.length > 0) {
        return formatters[0].formatter(value)
      }
      if (this.isBoolean(value)) {
        return value
          ? globalize('common.value-yes')
          : globalize('common.value-no')
      } else if (!value || this.isObject(value)) {
        return '-'
      // } else if (this.isDate(value)) {
      //   console.info('formatters', key, value)
      //   return formatDateDMYT(value)
      } else if (this.shortable) {
        return shortener(value)
      } else {
        return value
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/vue/common/DetailsReader/details-reader';
</style>
